import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {environment} from "../../../crud-table/models/environment.model";

@Injectable({
  providedIn: 'root'
})
export class Select2Service {
  API_URL = `${environment.apiUrl}`;
  myHeader = null;

  constructor(private http: HttpClient, private handler: HttpBackend) {}

  getCustomList(val, id, name, header = null) {
    return this.http.get<any>(`${this.API_URL}${val}`, {
      headers: header
    }).pipe(
      map(res => {
        const data = [];
        for (let i = 0; i < res.data.content.length; i++) {
          data.push({
            id: res.data.content[i][id],
            name: res.data.content[i][name]
          });
        }
        return data;
      }),
      catchError(err => {
        return throwError(err); })
    );
  }

}
